import Splide from "@splidejs/splide";

export default class LogoBoxesSlider {
    static init(): void {
        const slider: HTMLElement | null = document.querySelector(".logo-boxes-slider");
        if (!slider) return;

        const splide = new Splide(slider, {
            autoWidth: true,
            gap: "max(1.2rem, min(3vw, 5.2rem))",
            omitEnd: true,
            mediaQuery: "min",
            perMove: 1,
            perPage: 1,
            breakpoints: {
                768: {
                    perMove: 2,
                    perPage: 2,
                },
                1200: {
                    perMove: 3,
                    perPage: 3,
                },
            }
        });
        //@ts-ignore
        window._splide = splide;
        
        splide.mount();
    }
}
